import React, { FC, useState, useEffect } from 'react';
import { Icon, SelectionMode, DetailsListLayoutMode } from '@fluentui/react';
import { Dialog, DetailsList, ColumnInfo, Language } from '@eta/components';
import { useTranslation } from 'react-i18next';
import { IntermediaryStatusDto, IntermediaryStatuses } from '../Service/proxy';
import { UIHelpers } from '../../helpers/UIHelpers';

export interface Props {
    hidden: boolean;
    onClose: () => void;
    items: IntermediaryStatusDto[] | undefined;
    currentLanguage: Language;
}

export const StatusHistory: FC<Props> = (
    props: Props
) => {

    const {
        hidden,
        onClose,
        items: itemsProps,
        currentLanguage
    } = props;
    const { t } = useTranslation(['intermediaries', 'common']);
    const [columns, setColumns] = useState<ColumnInfo[]>();
    const [items, setItems] = useState<IntermediaryStatusDto[]>();

    useEffect(() => {
        setItems(itemsProps?.slice());
    }, [itemsProps]);

    useEffect(() => {
        const gridColumns = [
            {
                key: 'status',
                name: t('History.Status'),
                fieldName: 'status',
                minWidth: 150,
                maxWidth: 150,
                isResizable: true,
                isSortedDescending: false,
                onRender: (item: IntermediaryStatusDto) => {
                    return (
                        <span>{item.status === IntermediaryStatuses.Unblocked ? t('Active') : t('Inactive')}</span>
                    );
                },
            },
            {
                key: 'note',
                name: t('History.Reason'),
                fieldName: 'note',
                minWidth: 250,
                maxWidth: 250,
                isRowHeader: true,
                isResizable: false,
                onRender: (item: IntermediaryStatusDto) => {
                    return (
                        <span>{item.note}</span>
                    );
                },
            },
            {
                key: 'actionDate',
                name: t('History.Date'),
                fieldName: 'actionDate',
                minWidth: 120,
                maxWidth: 120,
                isRowHeader: true,
                isResizable: false,
                onRender: (item: IntermediaryStatusDto) => {
                    return (
                        <span>{UIHelpers.getLocalizedDateTime('Date', item.actionDate, currentLanguage.langIso4)}</span>
                    );
                },
            }
        ];
        setColumns(gridColumns);
    }, [t]);

    return (
        <Dialog
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={650}
            title={(
                <>
                    <Icon iconName='History' /> {t('AssignedAccessHistory')}
                </>
            )}
        >
            <div className='gridPopup'>
                <DetailsList
                    columns={columns ?? []}
                    items={items}
                    selectionMode={SelectionMode.none}
                    layoutMode={DetailsListLayoutMode.justified}
                    noItemsPlaceholder={<span>{t('common:NoRecords')} </span>}
                    labels={{ resultPerPage: t('common:nbItemPerPage'), totalRecord: t('common:totalRecord') }}
                    paginationSetting={{
                        nbItemPerPage: 10,
                        nbPageShown: 3 /* currentPage: 0, totalPage: 20 when managed externaly */,
                    }}
                />
            </div>
        </Dialog>
    );
};